import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import iconPencil from "../img/icons/icon-pencil.svg";
import iconTrash from "../img/icons/icon-trash.svg";
import {NavLink} from "react-router-dom";
import MD5 from "crypto-js/md5";

export default function ProposalEquipment(prop) {
    let proposalId = prop.proposalId;
    let member = prop.member;
    let readOnly = prop.readOnly;

    let refName = React.useRef();
    let refDetail = React.useRef();
    let refResearch = React.useRef();
    let refUsage = React.useRef();
    let refReason = React.useRef();
    let refUtilization = React.useRef();

    let [showForm, setShowForm] = React.useState(false);
    let [listing, setListing] = React.useState(null);
    let [editId, setEditId] = React.useState(null);
    let [view, setView] = React.useState(null);

    let [file1Base64, setFile1Base64] = React.useState(null);
    let [file2Base64, setFile2Base64] = React.useState(null);
    let [file3Base64, setFile3Base64] = React.useState(null);
    let refFile1Name = React.useRef();
    let refFile2Name = React.useRef();
    let refFile3Name = React.useRef();
    let refFile1 = React.useRef();
    let refFile2 = React.useRef();
    let refFile3 = React.useRef();
    const handleClickFile1 = React.useCallback(() => refFile1.current?.click(), []);
    const handleClickFile2 = React.useCallback(() => refFile2.current?.click(), []);
    const handleClickFile3 = React.useCallback(() => refFile3.current?.click(), []);
    let [file1Ext, setFile1Ext] = React.useState(null);
    let [file2Ext, setFile2Ext] = React.useState(null);
    let [file3Ext, setFile3Ext] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const proRes = await getList();
                setListing(proRes);
            } catch (e) {
                //
            }
        })();
    }, []);

    const onAddNew = () => {
        refName.current.value = '';
        refDetail.current.value = '';
        refResearch.current.value = '';
        refUsage.current.value = '';
        refReason.current.value = '';
        refUtilization.current.value = '';
        refFile1Name.current.value = '';
        refFile2Name.current.value = '';
        refFile3Name.current.value = '';
        setFile1Base64(null);
        setFile2Base64(null);
        setFile3Base64(null);
        setShowForm(true);
        setEditId(null);
    };
    const onCancel = () => {
        setShowForm(false);
    };
    const onEdit = async (id) => {
        const result = await getListView(id);
        if(result) {
            setView(result);
            setEditId(id);
            setShowForm(true);
            refName.current.value = result.name;
            refDetail.current.value = result.detail;
            refResearch.current.value = result.research;
            refUsage.current.value = result.usage;
            refReason.current.value = result.reason;
            refUtilization.current.value = result.utilization;
            refFile1Name.current.value = result.file1Name;
            refFile2Name.current.value = result.file2Name;
            refFile3Name.current.value = result.file3Name;
        }
    };
    const onSubmit = () => {
        let name = refName.current.value;
        let detail = refDetail.current.value;
        let research = refResearch.current.value;
        let usage = refUsage.current.value;
        let reason = refReason.current.value;
        let utilization = refUtilization.current.value;
        let file1Name = refFile1Name.current.value;
        let file2Name = refFile2Name.current.value;
        let file3Name = refFile3Name.current.value;

        if(name === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Name of equipment':'กรุณาระบุ ชื่อครุภัณฑ์');
            refName.current.focus();
        }
        else if(detail === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Equipment details':'กรุณาระบุ รายละเอียดครุภัณฑ์');
            refDetail.current.focus();
        }
        else if(usage === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Current usage status':'กรุณาระบุ สถานภาพการใช้งาน ณ ปัจจุบัน');
            refUsage.current.focus();
        }
        else if(reason === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Rationale and necessity for the project':'กรุณาระบุ เหตุผลและความจำเป็นต่อโครงการ');
            refReason.current.focus();
        }
        else if(utilization === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Utilization of this equipment when the plan is terminated':'กรุณาระบุ การใช้ประโยชน์ของครุภัณฑ์นี้เมื่อแผนงานสิ้นสุด');
            refUtilization.current.focus();
        }
        else if(!file1Name || !file2Name || !file3Name) {
            toast.error(prop.lang === 'en' ? 'Please specify document name':'กรุณาระบุ ชื่อเอกสาร');
        }
        else if(!editId && (!file1Base64 || !file2Base64 || !file3Base64)) {
            toast.error(prop.lang === 'en' ? 'Please specify Complete quotation file':'กรุณาระบุ ไฟล์ใบเสนอราคาให้ครบ');
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {

                            //extension file
                            let file1 = view?.file1 ?? null;
                            let file2 = view?.file2 ?? null;
                            let file3 = view?.file3 ?? null;
                            if(file1Ext) {
                                file1 = MD5('file1_' + moment().format("YMMDDHHmmss")).toString() + '.' + file1Ext;
                            }
                            if(file2Ext) {
                                file2 = MD5('file2_' + moment().format("YMMDDHHmmss")).toString() + '.' + file2Ext;
                            }
                            if(file3Ext) {
                                file3 = MD5('file3_' + moment().format("YMMDDHHmmss")).toString() + '.' + file3Ext;
                            }

                            let param = {
                                id: editId,
                                proposalId: proposalId, 
                                name: name.trim(),
                                detail: detail.trim(),
                                research: research.trim(),
                                usage: usage.trim(),
                                reason: reason.trim(),
                                utilization: utilization.trim(),
                                file1Name: file1Name,
                                file2Name: file2Name,
                                file3Name: file3Name,
                                file1: file1,
                                file2: file2,
                                file3: file3,
                                file1Base64: file1Base64,
                                file2Base64: file2Base64,
                                file3Base64: file3Base64,
                                currentFile1: view?.file1 ?? null,
                                currentFile2: view?.file2 ?? null,
                                currentFile3: view?.file3 ?? null,
                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await createItem(param);

                            if(result) {
                                if(result.status === 'success') {

                                    refName.current.value = '';
                                    refDetail.current.value = '';
                                    refResearch.current.value = '';
                                    refUsage.current.value = '';
                                    refReason.current.value = '';
                                    refUtilization.current.value = '';
                                    refFile1Name.current.value = '';
                                    refFile2Name.current.value = '';
                                    refFile3Name.current.value = '';
                                    setFile1Base64(null);
                                    setFile2Base64(null);
                                    setFile3Base64(null);

                                    toast.success(prop.lang === 'en' ? 'Add name successfully.':'บันทึกส่วนข้อมูลกลุ่มผู้ได้รับประโยชน์ เรียบร้อย');
                                    setShowForm(false);
                                    const teamRes = await getList();
                                    setListing(teamRes);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };
    const onDelete = (id) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        const result = await deleteItem(id);
                        if(result) {
                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Delete successfully.':'ลบข้อมูล เรียบร้อย');
                                setShowForm(false);
                                const teamRes = await getList();
                                setListing(teamRes);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function createItem(param) {
        const response = await fetch(Config.apiUrl +'/proposalEquipment/' + (editId ? 'updateItem':'createItem'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getList() {
        const response = await fetch(Config.apiUrl +'/proposalEquipment/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListView(id) {
        const response = await fetch(Config.apiUrl +'/proposalEquipment/viewItem', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function deleteItem(id) {
        const response = await fetch(Config.apiUrl +'/proposalEquipment/deleteItem', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="row g-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between gap-3">
                        <h6 className="pt-1"></h6>
                        {
                            readOnly ? '' : <button className="btn btn-xs btn-light-2" onClick={onAddNew}>
                                {prop.lang === 'en' ? '+ Add New':'+ เพิ่มรายการ'}
                            </button>
                        }
                    </div>
                    <div className="table-responsive mt-3">
                        <table className="table table-info table-hover text-center" style={{whiteSpace: 'nowrap'}}>
                            <thead>
                            <tr> 
                                <th className="text-center">{prop.lang === 'en' ? 'Name':'ชื่อครุภัณฑ์'}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Details':'รายละเอียดครุภัณฑ์'}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Related':<>ครุภัณฑ์ที่มีอยู่เดิม<br />และเครื่องมือที่เกี่ยวข้อง<br />กับงานวิจัย (ถ้ามี)</>}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Related':<>สถานภาพการใช้งาน<br /> ณ ปัจจุบัน</>}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Related':<>เหตุผลและความ<br />จำเป็นต่อโครงการ</>}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Related':<>การใช้ประโยชน์<br />ของครุภัณฑ์นี้<br />เมื่อแผนงานสิ้นสุด</>}</th>
                                {
                                    readOnly ? '' : <th style={{width: '100px'}}>แก้ไข</th>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {
                                listing !== null && listing.count > 0 ?
                                    listing.rows.map((row, index) => {
                                        return (
                                            <tr key={index}> 
                                                <td className="text-center">{row.name}</td>
                                                <td className="text-center">{row.detail}</td>
                                                <td className="text-center">{row.research}</td>
                                                <td className="text-center">{row.usage}</td>
                                                <td className="text-center">{row.reason}</td>
                                                <td className="text-center">{row.utilization}</td>
                                                {
                                                    readOnly ? '' : <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className="btn btn-trans" onClick={e => onEdit(row.id)}>
                                                                <img className="icons svg-js trash" src={iconPencil} alt="" />
                                                            </button>
                                                            <button className="btn btn-trans" onClick={e => onDelete(row.id)}>
                                                                <img className="icons svg-js trash" src={iconTrash} alt="" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    }) : <tr><td colSpan={7}>-</td></tr>
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className={"row g-3 mt-2" + (showForm ? '':' d-none')}> 
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Name of equipment':'ชื่อครุภัณฑ์'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refName} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Equipment details':'รายละเอียดครุภัณฑ์'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refDetail} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Existing equipment and tools related to research (if any)':'ครุภัณฑ์ที่มีอยู่เดิม และเครื่องมือที่เกี่ยวข้องกับงานวิจัย (ถ้ามี)'}</h6>
                                <input type="text" className="form-control" ref={refResearch} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Current usage status':'สถานภาพการใช้งาน ณ ปัจจุบัน'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refUsage} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Rationale and necessity for the project':'เหตุผลและความจำเป็นต่อโครงการ'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refReason} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Utilization of this equipment when the plan is terminated':'การใช้ประโยชน์ของครุภัณฑ์นี้เมื่อแผนงานสิ้นสุด'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refUtilization} maxLength={250} />
                            </div>
                        </div>

                        <div className="col-12">
                            <h6>{prop.lang === 'en' ? 'Quotations from 3 companies':'ใบเสนอราคาจาก 3 บริษัท'} <span className="star">*</span></h6>
                            <div className="table-responsive">
                                <table className="table table-info table-hover text-center">
                                    <thead>
                                    <tr>
                                        <th className="text-start">{prop.lang === 'en' ? 'Document Name':'ชื่อเอกสาร'}</th>
                                        {
                                            readOnly ? '' : <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</th>
                                        }
                                        {
                                            view?.file1 ? <th className="text-center" style={{width:'100px'}}>{view?.file1 ? (prop.lang === 'en' ? 'Download':'ดาวน์โหลด'):''}</th> : ''
                                        }
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td className="text-start">
                                            <input type="text" className="form-control" ref={refFile1Name} maxLength={250} disabled={!file1Base64 && !view || view && !view?.file1} />
                                        </td>
                                        {
                                            readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickFile1}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                        }
                                        {
                                            view?.file1 ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_equipment/' + view?.file1}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                        }
                                    </tr>
                                    <tr>
                                        <td className="text-start">
                                            <input type="text" className="form-control" ref={refFile2Name} maxLength={250} disabled={!file2Base64 && !view || view && !view?.file2} />
                                        </td>
                                        {
                                            readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickFile2}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                        }
                                        {
                                            view?.file2 ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_equipment/' + view?.file2}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                        }
                                    </tr>
                                    <tr>
                                        <td className="text-start">
                                            <input type="text" className="form-control" ref={refFile3Name} maxLength={250} disabled={!file3Base64 && !view || view && !view?.file3} />
                                        </td>
                                        {
                                            readOnly ? '' : <td><button type="button" className="input-group-text btn btn-sm btn-light" onClick={handleClickFile3}>{prop.lang === 'en' ? 'Select File':'เลือกไฟล์'}</button></td>
                                        }
                                        {
                                            view?.file3 ? <td><NavLink className={"input-group-text btn btn-sm"} target="_blank" to={Config.fileUpload + 'proposal_equipment/' + view?.file3}>{prop.lang === 'en' ? 'Download':'ดาวน์โหลด'}</NavLink></td> : ''
                                        }
                                    </tr>
                                    </tbody>
                                </table>

                                <input type="file" className="form-control d-none" ref={refFile1} onChange={(e) => {
                                    Utils.onSelectFile(e).then(
                                        data => {
                                            let name = e.target.files[0].name;
                                            let ext = name.split('.').pop();
                                            refFile1Name.current.value = name.replaceAll('.' +ext, '');
                                            setFile1Ext(ext);
                                            setFile1Base64(data);
                                        }
                                    );
                                }} accept={Utils.allowFileExtension} />

                                <input type="file" className="form-control d-none" ref={refFile2} onChange={(e) => {
                                    Utils.onSelectFile(e).then(
                                        data => {
                                            let name = e.target.files[0].name;
                                            let ext = name.split('.').pop();
                                            refFile2Name.current.value = name.replaceAll('.' +ext, '');
                                            setFile2Ext(ext);
                                            setFile2Base64(data);
                                        }
                                    );
                                }} accept={Utils.allowFileExtension} />

                                <input type="file" className="form-control d-none" ref={refFile3} onChange={(e) => {
                                    Utils.onSelectFile(e).then(
                                        data => {
                                            let name = e.target.files[0].name;
                                            let ext = name.split('.').pop();
                                            refFile3Name.current.value = name.replaceAll('.' +ext, '');
                                            setFile3Ext(ext);
                                            setFile3Base64(data);
                                        }
                                    );
                                }} accept={Utils.allowFileExtension} />
                            </div>
                        </div>

                        <div className="col-12 mt-4">
                            <div className="buttons gap-15 py-0">
                                <button className="btn btn-xs btn-green" type="button" onClick={onSubmit}>
                                    {prop.lang === 'en' ? 'Save':'บันทึก'}
                                </button>
                                <button className="btn btn-xs btn-gray me-auto" type="button" onClick={onCancel}>
                                    {prop.lang === 'en' ? 'Cancel':'ยกเลิก'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 